{ "id": "h-maser", "name": "Active hydrogen maser", "domain": "clock", "states": 3,
  "coefs": { "Q": 5.8e-5, "F": 0, "N": 2e-14, "B": 3e-16, "K": 0, "D": 0, "R": 1e-16 },
  "thermal": { "tempco": 0.00001, "tauTh": 7200 },
  "source": "Class values (MHM 2010 / iMaser): σy 1e-13 @1 s falling as τ⁻¹ (white PM, Q = 58 fs), 2e-15 @1e3 s, floor few e-16; drift ~1e-16/day. Inferred from class.",
  "inferred": ["Q", "N", "B", "R", "tempco"] }
